import IssueDetails from '@/components/Issues/IssueDetails';
import { useRecord } from '@/utils/genericResource';

export default function IssuesPage() {
  const record = useRecord('receivingIssues');

  return <IssueDetails issue={record} />;
}
